
class Sticky {
    
    constructor() {
      this.init();
    }

    init() {

      /* Scroll */

      const body = document.body
      const scrollUpClass     = "scroll-up";
      const scrollDownClass   = "scroll-down";
      const scrollBottomClass = "scroll-bottom";
      const thresholdClass    = "scroll-threshold";

      // Offset distance set to hero, otherwise header if no hero
      let thresholdTarget = document.querySelector(".hero");
      if (!thresholdTarget)
        thresholdTarget = document.querySelector(".header");
     
      let lastScroll = 0;

      window.addEventListener("scroll", () => {

        const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        const scrollHeight = (document.documentElement && document.documentElement.scrollHeight) || document.body.scrollHeight;
        const scrolledToBottom = (scrollTop + window.innerHeight) >= scrollHeight;

        const threshold = thresholdTarget.offsetHeight;
        const currentScroll = window.pageYOffset;

        // Scroll position is top of window
        if (currentScroll == 0) {
          body.classList.remove(scrollUpClass);

          if (!body.classList.contains(thresholdClass)) {
            body.classList.add(thresholdClass);
          }

          return;
        }
        
        // // Scroll position is bottom of window
        if (scrolledToBottom) {
          body.classList.add(scrollBottomClass);
        } else {
          body.classList.remove(scrollBottomClass);
        }

        if (currentScroll > threshold) {
          body.classList.remove(thresholdClass);
        } else {
          body.classList.add(thresholdClass);
        }

        if (currentScroll > threshold && currentScroll > lastScroll && !body.classList.contains(scrollDownClass)) {
          // down
          body.classList.remove(scrollUpClass);
          body.classList.add(scrollDownClass);
        } else if (currentScroll < lastScroll && body.classList.contains(scrollDownClass)) {
          // up
          body.classList.remove(scrollDownClass);
          body.classList.add(scrollUpClass);
        }
        lastScroll = currentScroll;
      });

    }

}

export default Sticky;



// WEBPACK FOOTER //
// ./scripts/components/sticky.js